import { UsState } from '@client/graphql/__generated__/types';
import { FC } from 'react';
import { Select, SelectProps } from './Select';

export interface UsStateSelectOption {
  label: UsState;
  value: UsState;
}

export const usStates = Object.keys(UsState) as Array<keyof typeof UsState>;

export const UsStateSelect: FC<SelectProps<UsStateSelectOption, false>> = (
  props
) => {
  return (
    <Select
      isClearable
      options={usStates.map((usState) => ({
        label: UsState[usState],
        value: UsState[usState],
      }))}
      {...props}
    />
  );
};
